// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GuidLookupModel from '../../model/guid-lookup-model';
import GuidLookupDTO from '../dto/guid-lookup-dto';
import dtoSchema from '../schemas/guid-lookup-schema';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class GuidLookupModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GuidLookupDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.caption = data.caption ?? undefined;
      this.details = data.details ?? undefined;
      this.sort = data.sort;
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  caption?: string;
  /**
  */
  details?: string;
  /**
  * @type {int32}
  */
  sort?: number;

  static toModel(dto: DeepPartial<GuidLookupDTO>): GuidLookupModel;
  static toModel(dto: DeepPartial<GuidLookupDTO> | undefined | null): GuidLookupModel | undefined;
  static toModel(dto: DeepPartial<GuidLookupDTO> | undefined | null): GuidLookupModel | undefined {
    return dto ? new GuidLookupModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GuidLookupModel> | GuidLookupModel): GuidLookupDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      caption: unwrapped.caption,
      details: unwrapped.details,
      sort: unwrapped.sort,
    } as GuidLookupDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GuidLookupModel, can not map to GuidLookupDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
